import { ReactNode } from 'react'
import { css } from '@emotion/react'

import Footer from '@/components/Footer'
import Navbar from '@/components/NavigationMenu/Navbar'
import ButtonToTop from '@/components/common/ButtonToTop'

import { useIsMobile } from '@/utils/useMobile'

import Spinner from '../common/SpinnerPage'
import FooterMobile from '../FooterMobile'

const wrapper = css`
  flex: 1 0 auto;
  overflow: hidden;
`

interface Props {
  children: ReactNode
  isLoading?: boolean
  fullPage?: boolean
  isFooter?: boolean
  isButtonTop?: boolean
}

function DefaultLayout(props: Props) {
  const {
    children,
    isLoading = false,
    fullPage = false,
    isFooter = true,
    isButtonTop = true
  } = props

  const { isMobile } = useIsMobile()

  return !isLoading ? (
    <>
      <Navbar />
      <main css={wrapper}>{children}</main>
      {isFooter && (isMobile ? <FooterMobile /> : <Footer />)}
      {isButtonTop && <ButtonToTop />}
      <div id="pricing-modal" />
    </>
  ) : (
    <Spinner fullPage={fullPage} />
  )
}

export default DefaultLayout
